import { inject, reactive, ref, watch, type Ref } from 'vue'
import { readSessionSort, writeSessionSort } from './tableState'
import { TABLE_PREFERENCES, type SortCriterion, type TableLayout, type TablePreferencesStore } from './types'

// Without a store from the app (tests, screens outside the session), layouts live in memory.
const memory = reactive(new Map<string, TableLayout>())
const memoryStore: TablePreferencesStore = {
  scope: () => 'local',
  layout: (tableId) => memory.get(tableId),
  save: (tableId, layout) => (layout ? memory.set(tableId, layout) : memory.delete(tableId)),
}

export function useTablePreferences(): TablePreferencesStore {
  return inject(TABLE_PREFERENCES, memoryStore)
}

// The sort of a table, kept in the session (sessionStorage) per scope (institution/console) and table.
// Screens that sort on the server use it to build the query and pass it to UiDataTable with v-model:sort.
export function useTableSort(tableId: string, defaultSort: SortCriterion[] = []): Ref<SortCriterion[]> {
  const store = useTablePreferences()
  const sort = ref<SortCriterion[]>(readSessionSort(store.scope(), tableId) ?? defaultSort)
  watch(sort, (value) => writeSessionSort(store.scope(), tableId, value), { deep: true })
  return sort
}
